(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cj-cart-promo-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-promo-banner')) {
    customElements.define('cart-promo-banner', class extends HTMLElement {
      connectedCallback() {
        const drawer = this.closest('cart-drawer-component');
        const footer = this.closest('[get-element-height]');
        if (!drawer || !footer) return;

        this.resizeObserver = new ResizeObserver(() => {
          drawer.style.setProperty('--set-container-height', `${footer.offsetHeight}px`);
        });
        this.resizeObserver.observe(footer);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
